<template>
  <div class="user" @dblclick="h()">
    <div class="photo">
      <div v-if="user">
        <img v-if="user.image" :src="user.image" alt="avatar" />
        <img v-else :src="defaultImage" alt="avatar" />
      </div>
      <img v-else :src="defaultImage" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ title }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav user-side-nav">
            <slot>
              <li>
                <router-link :to="`/pages/user/${user._id}`">Mein Profil</router-link>
              </li>
              <li>
                <router-link to="/pages/settings">Meine Apps</router-link>
              </li>
              <li>
                <router-link to="/pages/friends">Meine Freunde</router-link>
              </li>
              <li v-if="isAdmin">
                <router-link to="/pages/admin">Admin</router-link>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cc: 0,
      isClosed: true,
      defaultImage: "https://images.sports4me.at/img/default-avatar.png"
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isAdmin: state => state.isAdmin || false,
      title: state => (state.user && state.user.displayName) || "User"
    })
  },
  methods: {
    h() {
      console.log(this.cc);
      if (this.cc > 3) {
        this.$store.state.isAdmin = true;
      }
      this.cc++;
    },
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style lang="scss">
.user-side-nav {
  .router-link-active {
    background: #4caf50 !important;
  }
}
.collapsed {
  transition: opacity 1s;
}
</style>
